import React from 'react';
import { View, StyleSheet, Image } from 'react-native';

import { Text } from '../../core-ui';
import { WHITE_TWO, CAPTION_TEXT } from '../../constants/colors';

import { notAvailable } from '../../../assets';

function Billing() {
  return (
    <View style={styles.container}>
      <Image source={notAvailable} style={styles.image} />
      <Text type="header" style={styles.oopsText}>
        A wild roadblock has appeared
      </Text>
      <Text color={CAPTION_TEXT} style={styles.captionText}>
        Sorry, this feature is not available... yet.
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: WHITE_TWO,
  },
  oopsText: {
    fontSize: 26,
    marginBottom: 16,
  },
  captionText: {
    marginBottom: 28,
  },
  image: {
    width: 480,
    height: 320,
    marginBottom: 10,
  },
});

export default Billing;
